import { typographyCss } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import type { PredefinedTextVariants } from '@dealstack/frontend/shared/components/fundament/Text/Text.types';
import type { DsAiTypeStyle } from './dealstackAi.typography.types';

const DECLARATION = /(font-size|line-height|font-weight|letter-spacing):\s*([^;]+);/g;

/**
 * A Text variant's size, leading, weight and tracking as a style object, for Mantine `styles` and other
 * inline styles, which cannot take the styled-components fragment `typographyCss` returns.
 */
export const dsAiTypeStyle = (variant: PredefinedTextVariants): DsAiTypeStyle => {
	const text = typographyCss({ variant })
		.filter((chunk): chunk is string => typeof chunk === 'string')
		.join('');
	const declared = new Map(
		Array.from(text.matchAll(DECLARATION), ([, property, value]) => [property, value.trim()])
	);
	return {
		fontSize: declared.get('font-size'),
		lineHeight: declared.get('line-height'),
		fontWeight: declared.get('font-weight'),
		letterSpacing: declared.get('letter-spacing'),
	};
};
